import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
  userAttendanceStatusSelector,
  updateStagAttendance,
} from '../../../reducers';
import AttendanceStatus from './component';

const mapStateToProps = (state) => {
  return {
    attendanceStatus: userAttendanceStatusSelector(state),
  }
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    updateStagAttendance,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceStatus);



// WEBPACK FOOTER //
// ./src/component/organisms/AttendanceStatus/index.js